function handleHeaderScroll() {
    const header = document.querySelector('header');
    const scrollOffset = 100;

    if (window.scrollY >= scrollOffset) {
        header.classList.add('active');
        if (header.classList.contains('inicio')) {
            header.classList.remove('inicio');
            header.classList.add('inicio-disabled');
        }
    } else {
        header.classList.remove('active');
        if (header.classList.contains('inicio-disabled')) {
            header.classList.add('inicio');
            header.classList.remove('inicio-disabled');
        }
    }
}

window.addEventListener('scroll', handleHeaderScroll);


document.addEventListener("DOMContentLoaded", () => {
    const openMenu = document.querySelector(".hamburguer__menu");
    const closeMenu = document.querySelector(".close__hamburguer");
    const menu = document.querySelector(".header__area_enlaces");
    const backgroundBlack = document.querySelector(".background__black");

    const showMenu = () => {
        menu.classList.add("is-open");
        backgroundBlack.classList.add("activo");
        openMenu.setAttribute("aria-expanded", "true");
        closeMenu.focus();
    };

    const hideMenu = () => {
        menu.classList.remove("is-open");
        backgroundBlack.classList.remove("activo");
        openMenu.setAttribute("aria-expanded", "false");
        openMenu.focus();
    };

    openMenu.addEventListener("click", showMenu);
    closeMenu.addEventListener("click", hideMenu);
    backgroundBlack.addEventListener("click", hideMenu);

    [openMenu, closeMenu].forEach(control => {
        control.addEventListener("keydown", event => {
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                control.click();
            }
        });
    });
    document.addEventListener("keydown", event => {
        if (event.key === "Escape" && menu.classList.contains("is-open")) {
            hideMenu();
        }
    });
})
